const UPDATE_SDU_SUBSCRIPTION = 'UPDATE_SDU_SUBSCRIPTION';
const LOAD_BCC_CONTENT = 'LOAD_BCC_CONTENT';

export {
    UPDATE_SDU_SUBSCRIPTION, LOAD_BCC_CONTENT
};
